import { AdminType, APIGet, APIUrl } from "api/protocols";

interface IGetAccommodationRatePlanPrice {
  rate_plan_id?: number;
  unit_type_id?: number;
  start_date?: string;
  end_date?: string;
  facility_id: number;
}

export interface IPostAccommodationRatePlanPrice {
  rate_plan_id: number;
  unit_type_id: number;
  price: number;
  date: Date;
}

export interface IPutAccommodationRatePlanPrice {
  rate_plan_price_id: number;
  min_los?: number;
  max_los?: number;
  closed_to_arrival?: boolean;
  closed_to_departure?: boolean;
  closed?: boolean;
  price: number;
  rate_plan_price_ids?: number[];
}

// GET Accommodation Rate Plans
export async function GetAccommodationRatePlanPrices(params: IGetAccommodationRatePlanPrice, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.Guest, "/accommodation/prices"), params, useGlobalLoader);
}
